<template>
  <div class="modal-guide">
    <div class="modal-mask"></div>
    <div class="modal-content">
      <div class="guide guide-step-one"
           v-if="currentstep===1">
        <a href="javascript:;"
           class="btn btn-step btn-step-next"
           @click="stepTwo">下一步</a>
      </div>
      <div class="guide guide-step-two"
           v-if="currentstep===2">
        <a href="javascript:;"
           class="btn btn-step btn-step-prev"
           @click="stepOne">上一步</a>
        <a href="javascript:;"
           class="btn btn-step btn-step-next"
           @click="currentstep=3">下一步</a>
      </div>
      <div class="guide guide-step-three"
           v-if="currentstep===3">
        <a href="javascript:;"
           class="btn btn-step btn-step-prev"
           @click="currentstep=2">上一步</a>
        <a href="javascript:;"
           class="btn btn-step btn-step-next"
           @click="currentstep=4">下一步</a>
      </div>
      <div class="guide guide-step-four"
           v-if="currentstep===4">
        <a href="javascript:;"
           class="btn btn-step btn-step-close"
           @click="closeGuide">立即体验</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'guide',
  data () {
    return {
      currentstep: 1
    }
  },
  methods: {
    closeGuide () {
      this.$emit('guideStep', 'close')
    },
    stepOne () {
      this.$emit('guideStep', 'stepone')
      this.currentstep = 1
    },
    stepTwo () {
      this.$emit('guideStep', 'steptwo')
      this.currentstep = 2
    }
  }
}
</script>

<style lang="less">
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 93;
  width: 100%;
  height: 100%;
  background: transparent;
}
.modal-content {
  position: fixed;
  left: 0;
  top: 0;
  background: transparent;
  z-index: 94;
  width: 100%;
  height: 100%;
}
.guide {
  position: relative;
  width: 1400px;
  height: 840px;
  margin: 0 auto;
  &-step-one {
    background: url(/resource/images/bg_step1.png);
    .btn-step-next {
      position: absolute;
      top: 236px;
      right: 378px;
    }
  }
  &-step-two {
    background: url(/resource/images/bg_step2.png);
    .btn-step-next {
      position: absolute;
      top: 360px;
      left: 222px;
    }
    .btn-step-prev {
      position: absolute;
      top: 360px;
      left: 90px;
    }
  }
  &-step-three {
    background: url(/resource/images/bg_step3.png);
    .btn-step-next {
      position: absolute;
      top: 308px;
      right: 230px;
    }
    .btn-step-prev {
      position: absolute;
      top: 308px;
      right: 380px;
    }
  }
  &-step-four {
    background: url(/resource/images/bg_step4.png);
    .btn-step-close {
      position: absolute;
      top: 360px;
      left: 240px;
    }
  }
}
.btn-step {
  display: block;
  width: 110px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  &-next,
  &-close {
    background: #fd9d2b;
    color: #fff;
  }
  &-prev {
    border: 1px solid #fd9d2b;
    color: #fd9d2b;
    &:hover {
      background: #fd9d2b;
      color: #fff;
    }
  }
}
</style>
